export default __webpack_public_path__ + "static/media/ico-01.b6af69c3.png";